export default __webpack_public_path__ + "static/favicon-a3b604236d478c6e53db5a5523710d90.png";